import React from "react";
import Navbar from "./navbar";
import Tendances from "./tendances";
import Header from "./header";
import Temoignages from "./temoignages";
import Menu from "./menu";
import Contact from "./contact";
import Apropos from "./apropos";
import Chef from "./chef";
import Gallery from "./gallery";

function App() {
  return (
    <div>
      <Navbar />
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      <a
        href="https://wa.me/33662313849"
        class="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fa fa-whatsapp whatsapp-icon"></i>
      </a>
      <Header />
      <br></br>
      <Tendances />
      <br></br>
      <br></br>
      <Menu />

      <Temoignages />

      <br />
      <Apropos />

      <br />
      <Gallery />
      <br />
      <Contact />
    </div>
  );
}

export default App;
